module.exports = __webpack_public_path__ + "img/1234567893.8e0a031f.png";